import { render, staticRenderFns } from "./scope70.vue?vue&type=template&id=3d639e1c&scoped=true"
import script from "./scope70.vue?vue&type=script&lang=js"
export * from "./scope70.vue?vue&type=script&lang=js"
import style0 from "./scope70.vue?vue&type=style&index=0&id=3d639e1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d639e1c",
  null
  
)

export default component.exports